import React from 'react';
import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

import { useDarkenInteractionStyles } from '../../lib';

interface IButtonProps extends ChakraButtonProps {
	backgroundColor?: string;
	hoverDarken?: number; // Percentage to darken color on hover
	activeDarken?: number; // Percentage to darken color when active
}

export const Button: React.FunctionComponent<IButtonProps> = ({
	onClick,
	children,
	backgroundColor = 'blue.500',
	hoverDarken = 15,
	activeDarken = 30,
	...props
}) => {
	const { hoverStyle, activeStyle } = useDarkenInteractionStyles(backgroundColor, hoverDarken, activeDarken);
	return (
		<ChakraButton
			onClick={onClick}
			backgroundColor={backgroundColor}
			_hover={hoverStyle}
			_active={activeStyle}
			_focus={activeStyle}
			boxShadow='none'
			{...props}
		>
			{children}
		</ChakraButton>
	);
};
